import { lazy, Suspense, useState } from "react";
import { Button, Modal, Row } from "react-bootstrap";
import ColM from "../../assets/components/column/ColM";
import Icon from "../../assets/components/icon";
import Loader from "../../assets/components/loader/Loader";
import { TopBar } from "../../types/menuTypes";

const TopBarModal = ({ topBar }: TopBar) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const Component = lazy(() => import(`../modals/${topBar.page}`));

  return (
    <>
      <Button
        className="d-flex flex-column justify-content-center align-items-center "
        onClick={handleShow}
        style={{ width: "96px", height: "56px" }}
      >
        <Icon
          icon={topBar.icon}
          className=" topbar-icon mb-1"
          onClick={handleShow}
        />
        <span
          onClick={handleShow}
          style={{
            fontSize: "12px",
          }}
        >
          {topBar.name === "addEmployee" && "Medewerker"}
          {topBar.name === "addService" && "Service"}
        </span>
      </Button>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        centered
        size="xl"
        fullscreen={"xxl-down"}
        contentClassName="modal-background p-0"
      >
        <Modal.Body className="modal-background w-100 mh-100 ">
          <Row>
            <ColM xs={12}>
              <div className="d-flex justify-content-between align-items-center h-100">
                <h3 style={{ fontWeight: 200, marginBottom: 0 }}>
                  {topBar.name === "addEmployee" && "Medewerker toevoegen"}
                  {topBar.name === "addService" && "Service verzoek"}{" "}
                </h3>
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    padding: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  className="bg-secondary rounded-circle"
                  onClick={handleClose}
                >
                  <Icon
                    icon="close"
                    style={{ width: "10px", height: "10px" }}
                  />
                </div>
              </div>
            </ColM>
            <ColM>
              <Suspense fallback={<Loader pageTitle="Applicatie laden" />}>
                <Component />
              </Suspense>
            </ColM>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TopBarModal;
